import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { colors } from '@/theme/colors.theme'

import { FavoriteGamesTableComponent } from '../favorite-games'

export const GamesComponent = () => {
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        backgroundColor: colors.paper2,
        borderRadius: '16px',
        p: 3,
        mt: 1,
      }}
    >
      <Typography variant="h6" fontWeight={700} mb={2}>
        {t('personalizationEngine.favoriteGames')}
      </Typography>
      <FavoriteGamesTableComponent />
    </Box>
  )
}
